import { NgModule } from '@angular/core';
import { BackendModule, SearchModule } from '@shared/datastore/core';
import { searchContestsBackend } from './search-contests.backend';
import { transformSearchContests } from './search-contests.transformers';

@NgModule({
  imports: [
    SearchModule.forFeature('searchContests', transformSearchContests),
    BackendModule.forFeature('searchContests', searchContestsBackend),
  ],
})
export class DatastoreSearchContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-contests/search-contests.module.ts